import * as React from "react";
import { ISvgShape, SvgShapeComponent, ToolType } from "../../types/Floorplan.types";

export interface ISvgShapesProps {
    committedShapes?: ISvgShape[];
    selectedShapeIdx?: number;
    selectedTool?: ToolType;
}

const SvgShapes = (props: ISvgShapesProps) => {
    const { committedShapes, selectedShapeIdx, selectedTool } = props;

    const getPath = React.useCallback((shapeElements: SvgShapeComponent[]) => {
        return shapeElements.map((shape) => {
            let pathEl = "";
            switch (shape.type) {
                case "Move":
                    pathEl = `M ${shape.x} ${shape.y}`;
                    break;
                case "Line":
                    pathEl = `L ${shape.x} ${shape.y}`;
                    break;
                case "Curve":
                    pathEl = `Q ${shape.x1} ${shape.y1} ${shape.x} ${shape.y}`;
                    break;
                case "ReflectedCurve":
                    pathEl = `T ${shape.x} ${shape.y}`;
                    break;
                case "Closure":
                    pathEl = "Z";
                    break;
            }
            return pathEl;
        }).join(' ');
    }, []);

    if (committedShapes && committedShapes.length > 0) {
        return (
            <g id="shapes">
                { committedShapes.map((shape, idx) => {
                    let className = "shape shape-" + idx;
                    let transform: string | undefined = undefined;
                    if (selectedTool === "Pointer" && selectedShapeIdx === idx) {
                        className = "draggable draggableShape-" + idx;
                    }
                    if (shape.rotation !== 0) {
                        const originX = shape.width! / 2;
                        const originY = shape.height! / 2;
                        transform = `rotate(${shape.rotation}, ${originX}, ${originY})`;
                    }
                        
                    return (
                        <svg className={className} key={`shp_${idx}`} data-idx={idx} x={shape.x} y={shape.y} overflow="visible">
                            <g transform={transform}>
                                <path d={getPath(shape.path)} />
                            </g>
                        </svg>
                    );
                }) }
            </g>
        );
    }
    return null;
};

export default SvgShapes;